/**
 * JU!CE — Quiz de sabores (<jp-quiz>).
 * 3 perguntas client-side; cada resposta soma 1 ponto ao flavor_key marcado no editor.
 * Ao fim, o sabor com mais pontos vira o resultado real (nome, copy, pote e link da PDP,
 * lidos de um <script type="application/json" data-quiz-results> renderizado pelo Liquid
 * a partir dos blocks "resultado"). Empate: primeiro sabor da lista de resultados que
 * bateu o placar mais alto (ordem dos blocks no editor).
 *
 * Sem JS, este arquivo nunca carrega comportamento nenhum — o CSS (html:not(.js)) já
 * esconde a coluna de perguntas e deixa só o preview estático com link para #jp-sabores.
 */
(function () {
  'use strict';

  if (customElements.get('jp-quiz')) return;

  class JpQuizElement extends HTMLElement {
    connectedCallback() {
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-step]'));
      this.answers = Array.prototype.slice.call(this.querySelectorAll('[data-answer]'));
      this.doneEl = this.querySelector('[data-done]');
      this.doneFlavorEl = this.querySelector('[data-done-flavor]');
      this.redoBtn = this.querySelector('[data-redo]');
      this.panelEl = this.closest('.jp-quiz__panel');

      this.resultEl = this.querySelector('[data-result]');
      this.resultKicker = this.querySelector('[data-result-kicker]');
      this.resultName = this.querySelector('[data-result-name]');
      this.resultCopy = this.querySelector('[data-result-copy]');
      this.resultMedia = this.querySelector('[data-result-media]');
      this.resultCta = this.querySelector('[data-result-cta]');
      this.resultCtaLabel = this.querySelector('[data-result-cta-label]');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dots] [data-flavor]'));

      var dataScript = this.querySelector('script[data-quiz-results]');
      this.results = [];
      if (dataScript) {
        try {
          var parsed = JSON.parse(dataScript.textContent);
          if (Array.isArray(parsed)) this.results = parsed.filter(function (r) { return r && r.flavorKey; });
        } catch (err) {
          this.results = [];
        }
      }

      this.scores = {};
      this.currentStep = 0;

      this._onAnswerClick = this.onAnswerClick.bind(this);
      this.answers.forEach((btn) => {
        btn.addEventListener('click', this._onAnswerClick);
      });

      if (this.redoBtn) {
        this._onRedo = this.reset.bind(this);
        this.redoBtn.addEventListener('click', this._onRedo);
      }
    }

    disconnectedCallback() {
      var self = this;
      this.answers.forEach(function (btn) {
        btn.removeEventListener('click', self._onAnswerClick);
      });
      if (this.redoBtn && this._onRedo) this.redoBtn.removeEventListener('click', this._onRedo);
    }

    onAnswerClick(event) {
      var btn = event.currentTarget;
      var question = btn.getAttribute('data-question');
      var flavorKey = btn.getAttribute('data-flavor-key');
      if (!flavorKey) return;

      this.answers
        .filter(function (b) { return b.getAttribute('data-question') === question; })
        .forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });

      this.scores[flavorKey] = (this.scores[flavorKey] || 0) + 1;

      var self = this;
      window.setTimeout(function () { self.advance(); }, 260);
    }

    advance() {
      var current = this.steps[this.currentStep];
      if (current) current.setAttribute('hidden', '');

      this.currentStep += 1;
      var next = this.steps[this.currentStep];

      if (next) {
        next.removeAttribute('hidden');
        var firstAnswer = next.querySelector('[data-answer]');
        if (firstAnswer && typeof firstAnswer.focus === 'function') {
          firstAnswer.focus({ preventScroll: true });
        }
      } else {
        this.finish();
      }
    }

    pickWinner() {
      var scores = this.scores;
      var best = null;
      var bestScore = -1;
      this.results.forEach(function (result) {
        var score = scores[result.flavorKey] || 0;
        if (score > bestScore) {
          bestScore = score;
          best = result;
        }
      });
      return best || this.results[0] || null;
    }

    pickExample() {
      var marked = this.results.filter(function (r) { return r.exemplo; })[0];
      return marked || this.results[0] || null;
    }

    finish() {
      var winner = this.pickWinner();
      if (this.doneEl) this.doneEl.removeAttribute('hidden');
      if (this.doneFlavorEl) this.doneFlavorEl.textContent = winner ? (winner.nome || winner.flavorKey) : '';
      if (this.panelEl) this.panelEl.setAttribute('data-quiz-state', 'done');
      this.applyResult(winner, true);
      this.dispatchEvent(new CustomEvent('jp:quiz-complete', { bubbles: true, detail: { result: winner } }));
    }

    applyResult(result, isFinal) {
      if (!result || !this.resultEl) return;

      this.resultEl.setAttribute('data-flavor', result.flavorKey);
      if (this.resultName) this.resultName.textContent = result.nome || '';
      if (this.resultCopy) this.resultCopy.textContent = result.copy || '';

      if (this.resultMedia) {
        this.resultMedia.innerHTML = '';
        if (result.image) {
          var img = document.createElement('img');
          img.src = result.image;
          img.alt = '';
          img.loading = 'lazy';
          img.className = 'jp-quiz__result-img';
          this.resultMedia.appendChild(img);
        }
      }

      if (this.resultCta) {
        this.resultCta.setAttribute('href', result.url || '#jp-sabores');
        if (this.resultCtaLabel) {
          var ctaLabel = isFinal
            ? this.resultCta.getAttribute('data-match-label')
            : this.resultCta.getAttribute('data-start-label');
          this.resultCtaLabel.textContent = ctaLabel || this.resultCtaLabel.textContent;
        }
      }

      if (this.resultKicker) {
        var kickerLabel = isFinal
          ? this.resultKicker.getAttribute('data-match-kicker-label')
          : this.resultKicker.getAttribute('data-example-label');
        this.resultKicker.textContent = kickerLabel || this.resultKicker.textContent;
      }

      this.dots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.getAttribute('data-flavor') === result.flavorKey);
      });
    }

    reset() {
      this.scores = {};
      this.currentStep = 0;

      this.answers.forEach(function (btn) { btn.setAttribute('aria-checked', 'false'); });
      this.steps.forEach(function (step, index) {
        if (index === 0) step.removeAttribute('hidden');
        else step.setAttribute('hidden', '');
      });

      if (this.doneEl) this.doneEl.setAttribute('hidden', '');
      if (this.panelEl) this.panelEl.removeAttribute('data-quiz-state');

      var example = this.pickExample();
      this.applyResult(example, false);

      var firstAnswer = this.steps[0] && this.steps[0].querySelector('[data-answer]');
      if (firstAnswer && typeof firstAnswer.focus === 'function') {
        firstAnswer.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('jp-quiz', JpQuizElement);
})();
